<script>
import {baseURL} from '@/api';
import {watch} from 'vue';

export default {
  props: [
    'open'
  ],
  data: () => {
    return {
      activeSubMenu: '',
      publicKey: '',
      clearance: [],
      oldClearance: [],
      sdeWhiteLogo: require("../../../public/SDE_white_only.png"),
      socket: null,
      //HR
      menu_hr_usrs: false,
      menu_hr_deps: false,
      menu_hr_jots: false,
      //Supply
      menu_sup_inventory: false,
      menu_sup_exp_obj: false,
      menu_sup_invoice: false,
      menu_sup_req: false,
      menu_sup_prov: false,
      menu_sup_prod: false,
      menu_sup_trans: false,
      dev_only: false,

      reconnectInterval: null,
    }
  },
  methods: {
    /**
     * Toggles the visibility of a submenu.
     *
     * @param {string} menu - The menu to toggle.
     *
     * @return {void}
     */
    toggleSubMenu(menu) { // New method to handle submenu opening
      this.activeSubMenu = this.activeSubMenu === menu ? '' : menu;
    },
    processClearance(message) {

      this.clearance = JSON.parse(message);

      console.log("clearance: ", this.clearance);

      if (this.clearance === null) {
        this.clearance = []
      }

      if (this.oldClearance !== this.clearance) {
        this.$store.commit('updateSidebarData', this.clearance)
        this.oldClearance = this.clearance;
      }

      this.menu_hr_usrs = this.clearance.includes("hr-usr-search");
      this.menu_hr_deps = this.clearance.includes("hr-dep-search");
      this.menu_hr_jots = this.clearance.includes("hr-jot-search");
      this.menu_sup_inventory = this.clearance.includes("ad-prov-inventory-search");
      this.menu_sup_exp_obj = this.clearance.includes("ad-prov-expense-obj-search");
      this.menu_sup_invoice = this.clearance.includes("ad-prov-invoice-search");
      this.menu_sup_req = this.clearance.includes("ad-prov-requisition-search");
      this.menu_sup_prov = this.clearance.includes("ad-prov-providers-search");
      this.menu_sup_prod = this.clearance.includes("ad-prov-prod-search");
      this.menu_sup_trans = this.clearance.includes("ad-prov-transfer-search");
      this.dev_only = this.clearance.includes("it-dev-access");
    },

    connectWebSocket() {
      let protocol = (baseURL.indexOf('https://') === 0) ? 'wss://' : 'ws://';

      let wsBaseURL = baseURL.replace(/^https?:\/\//i, protocol);

      this.socket = new WebSocket(wsBaseURL + '/auth/clearance');

      this.socket.addEventListener('open', () => {
        this.socket.send('availableAccess');
      });

      this.socket.addEventListener('message', (event) => {
        this.processClearance(event.data);

      });

      this.socket.addEventListener('error', (event) => {
        console.error('WebSocket error: ', event);
      });

      this.socket.addEventListener('close', (event) => {
        console.log('WebSocket connection closed: ', event);
      });
    },

    reconnectWebSocket() {
      if (this.socket.readyState === 1) return;
      this.connectWebSocket()
    },
  },
  mounted() {
    this.connectWebSocket();

    this.reconnectInterval = setInterval(() => {
      this.reconnectWebSocket();
    }, 1000);
  },
  created() {
    //TODO properly handle reconnection
    watch(() => this.open, (newValue, oldValue) => {
      this.reconnectWebSocket();
      if (newValue && !oldValue && this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send('availableAccess');
      }
    })
  },
  beforeUnmount() {
    this.socket.close();
    clearInterval(this.reconnectInterval);
  },
}

</script>

<template>
  <transition name="show">
    <div class="SideNavBar" v-if="open">
      <div class="side-menu">
        <div class="menu-item">
          <a class="menu-item" v-if="menu_hr_jots || menu_hr_deps || menu_hr_usrs || dev_only"
             @click="toggleSubMenu('RecursosHumanos')">Recursos Humanos</a>
          <div v-if="activeSubMenu === 'RecursosHumanos'" class="submenu">
            <router-link @click="$emit('close')" to="/scene/manage_users" v-if="menu_hr_usrs">Usuarios</router-link>
            <router-link @click="$emit('close')" to="/scene/vacations" v-if="dev_only">Vacaciones</router-link>
            <router-link @click="$emit('close')" to="/scene/licences" v-if="dev_only">Licencias</router-link>
            <router-link @click="$emit('close')" to="/scene/leave_permit" v-if="dev_only">Permisos</router-link>
            <router-link @click="$emit('close')" to="/scene/manage_departments" v-if="menu_hr_deps">Departamentos
            </router-link>
            <router-link @click="$emit('close')" to="/scene/manage_job_titles" v-if="menu_hr_jots">Puestos de Trabajo
            </router-link>
          </div>
        </div>
        <div class="menu-item">
          <a class="menu-item"
             v-if="menu_sup_inventory || menu_sup_exp_obj || menu_sup_invoice || menu_sup_prov || menu_sup_req || menu_sup_prod"
             @click="toggleSubMenu('Proveeduría')">Proveeduría</a>
          <div v-if="activeSubMenu === 'Proveeduría'" class="submenu">
            <router-link @click="$emit('close')" to="/scene/manage_product_invoice" v-if="menu_sup_invoice">Facturas
            </router-link>
            <router-link @click="$emit('close')" to="/scene/current_inventory" v-if="menu_sup_inventory">Inventario
            </router-link>
            <router-link @click="$emit('close')" to="/scene/expense_objects" v-if="menu_sup_exp_obj">Objetos del gasto
            </router-link>
            <router-link @click="$emit('close')" to="/scene/manage_products" v-if="menu_sup_prod">Productos
            </router-link>
            <router-link @click="$emit('close')" to="/scene/providers" v-if="menu_sup_prov">Proveedores</router-link>
            <router-link @click="$emit('close')" to="/scene/manage_requisitions" v-if="menu_sup_req">Requisiciones
            </router-link>
            <router-link @click="$emit('close')" to="/scene/manage_transfers" v-if="menu_sup_trans">Transferencias
            </router-link>
          </div>
        </div>

        <div class="fixed-bottom"> <!-- This div contains your image -->
          <img :src=sdeWhiteLogo alt="SDE logo white">
        </div>

      </div>

    </div>
  </transition>
</template>

<style scoped>
.side-menu {
  position: fixed;
  left: 0;
  top: 48px;
  width: 250px;
  height: calc(100vh - 48px);;
  overflow-y: auto;
  background: var(--gobBlue);
  z-index: 3;
}

.side-menu a {
  display: block;
  padding: 10px 15px; /* Adjust padding as per your needs */
  font-size: 15px;
  text-align: left;
  text-decoration: none;
  color: #ffffff;
  border-bottom: 1px solid #ffffff; /* This is the line */
}

.side-menu a:hover {
  background-color: var(--gobGolden);
}

.menu-item {
  cursor: pointer;
  color: #ffffff;
}

.submenu {
  background: var(--gobGray);
}

.menu-item, .submenu {
  width: auto;
  white-space: nowrap;
  border-radius: 0;
}

.fixed-bottom {
  position: fixed;
  bottom: 0;
  width: 250px;
}

.fixed-bottom img {
  height: 100px;
  padding-bottom: 10px

}


@media (max-width: 600px) {
  .side-menu {
    width: 75vw;
  }

}
</style>